import { useEffect, useState } from 'react';
import { RootState } from '../../modules';
import { useDispatch, useSelector } from 'react-redux';
import { VendorType, getVendorDetailAsync } from '../../modules/vendors';
import { Drawer } from 'antd';
import VendorEditDrawer from './VendorEditDrawer';
import VendorCompanyDetailComponent from '../../components/vendors/VendorCompanyDetailComponent';
import VendorWorkerDetailComponent from '../../components/vendors/VendorWorkerDetailComponent';

export interface VendorDetailDrawerProps {
  config: any;
  visible: boolean;
  onClose: () => void;
}

function VendorDetailDrawer({
  config,
  visible,
  onClose,
}: VendorDetailDrawerProps) {
  const vendor = useSelector((state: RootState) => state.vendors.vendor.data);
  const [visibleEditlDrawer, setVisibleEditDrawer] = useState<boolean>(false);
  const [editDrawerConfig, setEditDrawerConfig] = useState<any>();
  // const [visiblePdfView, setVisiblePdfView] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getVendorDetailAsync.request({
        enterpriseId: config.enterpriseId,
        vendorId: config.vendorId,
      }),
    );
  }, [dispatch, config]);

  const moveToEditPage = () => {
    setEditDrawerConfig({ ...config });
    setVisibleEditDrawer(true);
  };

  const onCloseEditDrawer = () => {
    setVisibleEditDrawer(false);
  };

  // const onOpenPdfView = () => setVisiblePdfView(true);
  // const onClosePdfView = () => setVisiblePdfView(false);

  const _downloadFile = () => {
    console.log('_downloadFile');
    // saveAs(
    //   vendor?.file[0].url,
    //   `${vendor?.billingDate}_${vendor?.vendor.application.general.name}.pdf`,
    // );
  };

  // const onUpdate = async (_vendor: any) => {
  //   console.log('onUpdate');
  //   console.log(_vendor);
  //   console.log(data);
  //   const vendor = {
  //     ..._vendor,
  //     expirationDate: moment(_vendor.expirationDate).format('YYYY-MM-DD'),
  //   };
  //   await updateVendorPQStatus({ enterpriseId, vendorId, vendor });
  //   dispatch(getVendorDetailAsync.request({ enterpriseId, vendorId }));
  //   setVisible(false);
  // };

  return (
    <>
      {vendor && (
        <Drawer
          width={1000}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
        >
          {visible && vendor.type === VendorType.COMPANY && (
            <VendorCompanyDetailComponent
              vendor={vendor}
              downloadFile={_downloadFile}
              moveToEditPage={moveToEditPage}
            />
          )}
          {visible && vendor.type === VendorType.WORKER && (
            <VendorWorkerDetailComponent
              vendor={vendor}
              downloadFile={_downloadFile}
              moveToEditPage={moveToEditPage}
            />
          )}
        </Drawer>
      )}
      {vendor && editDrawerConfig && (
        <VendorEditDrawer
          config={editDrawerConfig}
          vendor={vendor}
          visible={visibleEditlDrawer}
          onClose={onCloseEditDrawer}
        />
      )}
    </>
  );
}

export default VendorDetailDrawer;
